export default __webpack_public_path__ + "static/media/ER20.99d1ac23.jpg";